import { render, staticRenderFns } from "./SmsModel.vue?vue&type=template&id=16713d24&"
import script from "./SmsModel.vue?vue&type=script&lang=ts&"
export * from "./SmsModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports